
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7d5b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7d5b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9jJkP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c890dfcfb08bdd7$export$2e2bcd8739ae039; });

var $3aJhI = parcelRequire("3aJhI");
const $6c890dfcfb08bdd7$var$data = [
    {
        "id": 1,
        "name": "Opryskiwacz spalinowy Stihl SR450",
        "description": "Komfortowy opryskiwacz o du\u017Cym zasi\u0119gu oprysku. \u0141atwy w obs\u0142udze. Z pojemnym zbiornikiem. Szybkie uruchamianie urz\u0105dzenia. Model wyposa\u017Cony w praktyczny mechanizm do przezbrojenia 2w1, kt\xf3ry umo\u017Cliwia wykonywanie zar\xf3wno oprysk\xf3w jak i rozpylanie granulatu.",
        "image": (0, $3aJhI.default).opryskiwacz,
        "category": "Opryskiwacze i dmuchawy",
        "technical_data": [
            {
                "name": "Ci\u0119\u017Car",
                "value": "12,8 kg"
            },
            {
                "name": "Pojemno\u015B\u0107 zbiornika na rozpylan\u0105 substancj\u0119",
                "value": "14l"
            },
            {
                "name": "Zawarto\u015B\u0107 zbiornika paliw",
                "value": "1,7l"
            },
            {
                "name": "Maksymalny zasi\u0119g opryskiwania horyzontalnie",
                "value": "14,5m"
            }
        ],
        "price": {
            "rental_price": "120z\u0142",
            "deposit": "300z\u0142"
        }
    },
    {
        "id": 2,
        "name": "No\u017Cyce spalinowe Stihl HS 45",
        "description": "Wyj\u0105tkowo lekkie no\u017Cyce do \u017Cywop\u0142ot\xf3w do piel\u0119gnacji \u017Cywop\u0142ot\xf3w w przydomowym ogrodzie. Doskona\u0142e do nadawania formy \u017Cywop\u0142otom oraz krzewom do wysoko\u015Bci klatki piersiowej u\u017Cytkownika. Specjalna geometria ostrza zapewnia czyste, precyzyjne ci\u0119cie. System antywibracyjny STIHL",
        "technical_data": [
            {
                "name": "Ci\u0119\u017Car:",
                "value": "5 kg"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 listwy tn\u0105cej ",
                "value": "60cm"
            }
        ],
        "price": {
            "rental_price": "80z\u0142",
            "deposit": "200z\u0142"
        },
        "image": (0, $3aJhI.default).nozyce2,
        "category": "No\u017Cyce do \u017Cywop\u0142otu i sekatory"
    },
    {
        "id": 3,
        "name": "Elektryczne no\u017Cyce do \u017Cywop\u0142ot\xf3w Stihl HS 81",
        "description": "Trwa\u0142e, elektryczne no\u017Cyce do \u017Cywop\u0142ot\xf3w, kt\xf3re przeznaczone\xa0s\u0105 do ci\u0119cia twardych \u017Cywop\u0142ot\xf3w.",
        "technical_data": [
            {
                "name": "Silnik",
                "value": "1 KM"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 ostrza",
                "value": "60cm"
            },
            {
                "name": "Ci\u0119\u017Car",
                "value": "5,6kg"
            }
        ],
        "price": {
            "rental_price": "80z\u0142",
            "deposit": "200z\u0142"
        },
        "image": (0, $3aJhI.default).nozyce1,
        "category": "No\u017Cyce do \u017Cywop\u0142otu i sekatory"
    },
    {
        "id": 6,
        "name": "Kosa spalinowa Stihl FS 240",
        "description": "",
        "technical_data": [
            {
                "name": "D\u0142ugo\u015B\u0107 ca\u0142kowita",
                "value": "180cm"
            },
            {
                "name": "Ci\u0119\u017Car",
                "value": "6,9kg"
            },
            {
                "name": "Moc",
                "value": "11,7kW/2,3KM"
            },
            {
                "name": "\u015Arednica ci\u0119cia",
                "value": "420mm"
            }
        ],
        "price": {
            "rental_price": "120z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).kosa,
        "category": "Kosiarki i kosy"
    },
    {
        "id": 7,
        "name": "Podkaszarka Stihl FS87",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "1,3 KM"
            },
            {
                "name": "Ci\u0119\u017Car",
                "value": "5,6kg"
            }
        ],
        "price": {
            "rental_price": "60z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).fs87,
        "category": "Kosiarki i kosy"
    },
    {
        "id": 8,
        "name": "Dmuchawa SH56",
        "description": "Idealna do oczyszczania \u015Bredniej wielko\u015Bci powierzchni. P\u0142ynna regulacja obrot\xf3w, dysza okr\u0105g\u0142a, n\xf3\u017C rozdrabniaj\u0105cy, silnik 2-MIX.\xa0",
        "technical_data": [
            {
                "name": "Ci\u0119\u017Car",
                "value": "5,6kg"
            }
        ],
        "price": {
            "rental_price": "80z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).dmuchawa2,
        "category": "Opryskiwacze i dmuchawy"
    },
    {
        "id": 9,
        "name": "Dmuchawa Stihl BG86",
        "description": "Do oczyszczania du\u017Cych powierzchni z li\u015Bci i skoszonej trawy. Filtr HD2 umo\u017Cliwia zastosowanie urz\u0105dzenia r\xf3wnie\u017C w warunkach du\u017Cego zapylenia.",
        "technical_data": [
            {
                "name": "Waga",
                "value": "4,4kg"
            },
            {
                "name": "Wydajno\u015B\u0107",
                "value": "770m3/min"
            }
        ],
        "price": {
            "rental_price": "80z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).dmuchawa1,
        "category": "Opryskiwacze i dmuchawy"
    },
    {
        "id": 10,
        "name": "Wertykulator World",
        "description": "Korpus jest\xa0spawany\xa0ze stali i posiada szereg wzmocnie\u0144 kt\xf3re czyni\u0105 go bardzo solidnym.Posiada\xa0centraln\u0105 6-pozycyjn\u0105 regulacj\u0119 wysoko\u015Bci\xa0w zakresie (-12mm do +12mm). Wertykulator posiada\xa0no\u017Ce p\u0142ywaj\u0105ce",
        "technical_data": [
            {
                "name": "",
                "value": ""
            }
        ],
        "price": {
            "rental_price": "140z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).wertykulator,
        "category": "Wertykulatory i Aeratory"
    },
    {
        "id": 11,
        "name": "Glebogryzarka Viking HB 560",
        "description": "",
        "technical_data": [
            {
                "name": "Typ silnika",
                "value": "Kohler Serie XT675 OHV SC"
            },
            {
                "name": "Szeroko\u015B\u0107 robocza",
                "value": "60cm"
            },
            {
                "name": "Ci\u0119\u017Car urz\u0105dzenia",
                "value": "41 kg"
            }
        ],
        "price": {
            "rental_price": "120z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).glebogryzarka,
        "category": "Glebogryzarki"
    },
    {
        "id": 12,
        "name": "Zag\u0119szczarka 196CC",
        "description": "Zag\u0119szczarka gruntu p\u0142ytowa ubijak wibrator 196cc 6,5KM 90kg",
        "technical_data": [
            {
                "name": "Maksymalny posuw ",
                "value": "15m/min"
            },
            {
                "name": "Si\u0142a zag\u0119szczenia",
                "value": "1300kg"
            }
        ],
        "price": {
            "rental_price": "100z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).zageszczarka2,
        "category": "Narz\u0119dzia budowlane"
    },
    {
        "id": 13,
        "name": "Zag\u0119szczarka Belle 120kg",
        "description": "",
        "technical_data": [
            {
                "name": "Waga",
                "value": "120kg"
            },
            {
                "name": "Silnik",
                "value": "Honda GX 160 5,5KM"
            },
            {
                "name": "Szeroko\u015B\u0107 p\u0142yty",
                "value": "50cm"
            },
            {
                "name": "Si\u0142a wymuszaj\u0105ca",
                "value": "20 kN"
            },
            {
                "name": "Pr\u0119dko\u015B\u0107 przesuwu",
                "value": "25m / min"
            }
        ],
        "price": {
            "rental_price": "100z\u0142",
            "deposit": "500z\u0142"
        },
        "image": (0, $3aJhI.default).zageszczarka3,
        "category": "Narz\u0119dzia budowlane"
    },
    {
        "id": 14,
        "name": "Pilarka spalinowa Stihl MS391",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "4,5 KM"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 prowadnicy",
                "value": "38 / 45cm"
            },
            {
                "name": "Ci\u0119\u017Car",
                "value": "7,2 kg"
            }
        ],
        "price": {
            "rental_price": "120z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).ms391,
        "category": "Pi\u0142y i podkrzesywarki"
    },
    {
        "id": 15,
        "name": "Pilarka spalinowa Stihl MS200",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "2,3 KM"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 prowadnicy",
                "value": "33 / 45cm "
            },
            {
                "name": "Ci\u0119\u017Car",
                "value": "3,5 kg"
            }
        ],
        "price": {
            "rental_price": "140z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).ms200,
        "category": "Pi\u0142y i podkrzesywarki"
    },
    {
        "id": 16,
        "name": "Pilarka spalinowa Stihl MS193D",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "1,8 KM"
            },
            {
                "name": "Ci\u0119\u017Car",
                "value": "3,3 kg"
            }
        ],
        "price": {
            "rental_price": "140z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).ms193,
        "category": "Pi\u0142y i podkrzesywarki"
    },
    {
        "id": 17,
        "name": "Przecinarka Stihl TS420",
        "description": "Uniwersalna przecinarka do prac budowlanych. \u015Aciernica o \u015Brednicy 350 mm do ci\u0119\u0107 o g\u0142\u0119boko\u015Bci do 125 mm. System antywibracyjny STIHL zapewnia precyzyjne i wygodne prowadzenie przecinarki",
        "technical_data": [
            {
                "name": "Moc",
                "value": "4,4 KM"
            },
            {
                "name": "\u015Arednica tarczy tn\u0105cej",
                "value": "350mm"
            },
            {
                "name": "Ci\u0119\u017Car",
                "value": "9,7 kg"
            }
        ],
        "price": {
            "rental_price": "100z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).ts420,
        "category": "Narz\u0119dzia budowlane"
    },
    {
        "id": 18,
        "name": "Piaskarka/Rozsiewacz ziemi Dakr ",
        "description": "Rozsiewacz Dakr KRR jest przeznaczony do wykonywania zabieg\xf3w top-dressingu (piaskowania) na boiskach, w parkach i ozdobnych trawnikach.Praca z rozsiewaczem nie wymaga du\u017Cego wysi\u0142ku, du\u017Ce ko\u0142a sprawiaj\u0105, \u017Ce maszyn\u0119 prowadzi si\u0119 lekko. D\u017Awignia przy r\u0105czce aktywuje funkcj\u0119 rozsiewania, a regulacja ilo\u015Bci podawanego materia\u0142u umo\u017Cliwia dostosowanie grubo\u015Bci warstwy piasku to warunk\xf3w i typu zabiegu.",
        "technical_data": [
            {
                "name": "Pojemno\u015B\u0107 zbiornika",
                "value": "180 litr\xf3w"
            },
            {
                "name": "Szeroko\u015B\u0107 robocza",
                "value": "70cm"
            },
            {
                "name": "Waga",
                "value": "40kg"
            }
        ],
        "price": {
            "rental_price": "120z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).dakr1,
        "category": "Siewniki, walce, rozsiewacze"
    },
    {
        "id": 19,
        "name": "Taczka Cedrus",
        "description": "Transporter spalinowy Cedrus TR300 to idealna maszyna do transportu wszelkiego rodzaju materia\u0142\xf3w. Silnik czterosuwowy o pojemno\u015Bci 196cm3 pozwala na wydajn\u0105 prac\u0119 w ka\u017Cdych warunkach. Terenowe opony z agresywnym bie\u017Cnikiem pomagaj\u0105 w trudnym terenie budowy. Mechaniczna przek\u0142adnia z 3 prze\u0142o\u017Ceniami do przodu oraz biegiem wstecznym pozwala dostosowa\u0107 pr\u0119dko\u015B\u0107 do wykonywanej pracy oraz przewo\u017Conego materia\u0142u.",
        "technical_data": [
            {
                "name": "\u0141atwe manewrowanie w w\u0105skich miejscach np. przez w\u0105skie drzwi i konstrukcje",
                "value": ""
            },
            {
                "name": "Solidna konstrukcja ze stali",
                "value": ""
            },
            {
                "name": "Bezobs\u0142ugowa przek\u0142adnia",
                "value": ""
            },
            {
                "name": "Prosta obs\u0142uga",
                "value": ""
            },
            {
                "name": "Mocny 4-suwowy silnik spalinowy OHV\xa0",
                "value": ""
            },
            {
                "name": "Na wytrzyma\u0142ych terenowych oponach",
                "value": ""
            },
            {
                "name": "Przewo\u017Cenie du\u017Cych \u0142adunk\xf3w",
                "value": ""
            },
            {
                "name": "Zast\u0105pi\u0107 mo\u017Ce tradycyjn\u0105 taczk\u0119 w wielu miejscach",
                "value": ""
            }
        ],
        "price": {
            "rental_price": "150z\u0142",
            "deposit": "500z\u0142"
        },
        "image": (0, $3aJhI.default).taczki,
        "category": "Taczki i przyczepki"
    },
    {
        "id": 20,
        "name": "Crawler Spider CMC S18",
        "description": "",
        "technical_data": [
            {
                "name": "Wysoko\u015B\u0107 robocza",
                "value": "17,7 m"
            },
            {
                "name": "Maksymalny zasi\u0119g poziomy",
                "value": "11,3 m"
            },
            {
                "name": "Waga",
                "value": "2490 kg"
            },
            {
                "name": "Ud\u017Awig",
                "value": "230 kg"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 transportowa",
                "value": "5,3 m"
            },
            {
                "name": "Szeroko\u015B\u0107 transportowa",
                "value": "1,06 m"
            },
            {
                "name": "Wysoko\u015B\u0107 transportowa",
                "value": "2,28 m"
            },
            {
                "name": "Silnik",
                "value": "Honda GX390"
            },
            {
                "name": "Liczba os\xf3b na platformie",
                "value": "2"
            }
        ],
        "price": {
            "rental_price": "600z\u0142",
            "deposit": "4000z\u0142"
        },
        "image": (0, $3aJhI.default).crawler,
        "category": "Podno\u015Bniki"
    },
    {
        "id": 42,
        "name": "Avant 630",
        "description": "",
        "technical_data": [
            {
                "name": "Ud\u017Awig nominalny",
                "value": "1190 kg"
            },
            {
                "name": "Wysoko\u015B\u0107 podnoszenia",
                "value": "2835 mm"
            },
            {
                "name": "Pr\u0119dko\u015B\u0107 maksymalna",
                "value": "23 km/h"
            },
            {
                "name": "Moc silnika",
                "value": "19 kW (26 KM)"
            }
        ],
        "price": {
            "rental_price": "700z\u0142",
            "deposit": "3000z\u0142"
        },
        "image": (0, $3aJhI.default).avant630,
        "category": "Minikoparki"
    },
    {
        "id": 21,
        "name": "R\u0119bak Timberwolf",
        "description": "Silny, wytrzyma\u0142y, mocny i szybki. Taki jest TW 230DHB. Tam gdzie prac\u0119 nale\u017Cy wykona\u0107 szybko i bez zb\u0119dnego zamieszania. \u0141atwy w konserwacji i transporcie. Wa\u017Cy poni\u017Cej 750 kg, wi\u0119c mo\u017Cna holowa\u0107 go z kategori\u0105 B. ",
        "technical_data": [
            {
                "name": "Maksymalna \u015Brednica materia\u0142u",
                "value": "160mm"
            },
            {
                "name": "Masa w\u0142asna",
                "value": "749kg"
            },
            {
                "name": "Otw\xf3r za\u0142adowczy",
                "value": "230 x 160mm"
            },
            {
                "name": "Wydajno\u015B\u0107 r\u0119baka",
                "value": "5 t/h"
            },
            {
                "name": "Nap\u0119d r\u0119baka",
                "value": "Kubota 35 KM 4-cylindrowy"
            }
        ],
        "price": {
            "rental_price": "600z\u0142",
            "deposit": "2000z\u0142"
        },
        "image": (0, $3aJhI.default).rebak,
        "category": "R\u0119baki"
    },
    {
        "id": 22,
        "name": "Walec, napowietrzacz",
        "description": "",
        "technical_data": [
            {
                "name": "Szeroko\u015B\u0107",
                "value": "60cm"
            }
        ],
        "price": {
            "rental_price": "40z\u0142",
            "deposit": "50z\u0142"
        },
        "image": (0, $3aJhI.default).walec,
        "category": "Siewniki, walce, rozsiewacze"
    },
    {
        "id": 23,
        "name": "Drabina",
        "description": "",
        "technical_data": [
            {
                "name": "Wysoko\u015B\u0107 robocza",
                "value": "9m"
            }
        ],
        "price": {
            "rental_price": "70z\u0142",
            "deposit": "250z\u0142"
        },
        "image": (0, $3aJhI.default).drabina,
        "category": "Narz\u0119dzia techniczne"
    },
    {
        "id": 24,
        "name": "Przyczepka",
        "description": "",
        "technical_data": [
            {
                "name": "Ud\u017Awig",
                "value": "500kg"
            },
            {
                "name": "Wymiary",
                "value": "150cm x 200cm"
            }
        ],
        "price": {
            "rental_price": "50z\u0142",
            "deposit": "200z\u0142"
        },
        "image": (0, $3aJhI.default).przeczepka,
        "category": "Taczki i przyczepki"
    },
    {
        "id": 25,
        "name": "Siewnik Wolf Garten",
        "description": "",
        "technical_data": [
            {
                "name": "Pojemno\u015B\u0107 zbiornika",
                "value": "15L"
            },
            {
                "name": "Szeroko\u015B\u0107 siewu",
                "value": "41cm"
            }
        ],
        "price": {
            "rental_price": "40z\u0142",
            "deposit": "50z\u0142"
        },
        "image": (0, $3aJhI.default).siewnik,
        "category": "Siewniki, walce, rozsiewacze"
    },
    {
        "id": 26,
        "name": "Areator rurkowy Weibang WB457AB",
        "description": "Aerator rurkowy Weibang WB457AB to profesjonalne narz\u0119dzie do napowietrzania gleby. Dzi\u0119ki niemu znikn\u0105 problemy z optymalnym nawadnianiem i napowietrzaniem trawnika. Rurki z wysokogatunkowej stali wbijaj\u0105 si\u0119 w gleb\u0119 umo\u017Cliwiaj\u0105c wnikanie przez ni\u0105 wody, zwi\u0105zk\xf3w organicznych i powietrza u\u0142atwiaj\u0105c ich odbi\xf3r przez system korzeniowy traw.",
        "technical_data": [
            {
                "name": "",
                "value": ""
            }
        ],
        "price": {
            "rental_price": "250z\u0142",
            "deposit": "500z\u0142"
        },
        "image": (0, $3aJhI.default).agregator,
        "category": "Wertykulatory i Aeratory"
    },
    {
        "id": 27,
        "name": "Kosiarka spalinowa Castel Garden XC 53 HS ",
        "description": "",
        "technical_data": [
            {
                "name": "Wysoko\u015B\u0107 koszenia",
                "value": "27 do 90mm"
            },
            {
                "name": "Szeroko\u015B\u0107 koszenia",
                "value": "51cm"
            },
            {
                "name": "Regulacja wysoko\u015Bci koszenia",
                "value": "centralna"
            },
            {
                "name": "Ko\u0142a",
                "value": "200 / 280mm"
            },
            {
                "name": "Pojemno\u015B\u0107 kosza",
                "value": "60 litr\xf3w"
            },
            {
                "name": "Pojemno\u015B\u0107 silnika",
                "value": "167 cm3"
            }
        ],
        "price": {
            "rental_price": "80z\u0142",
            "deposit": "250z\u0142"
        },
        "image": (0, $3aJhI.default).kosiarka2,
        "category": "Kosiarki i kosy"
    },
    {
        "id": 28,
        "name": "Kosiarka spalinowa z nap\u0119dem Viking 46cm",
        "description": "",
        "technical_data": [
            {
                "name": "Powierzchnia trawnika m\xb2",
                "value": "do 1200"
            },
            {
                "name": "Typ silnika",
                "value": "B&S Serie 575 EX OHV RS"
            },
            {
                "name": "Moc znamionowa",
                "value": "2,1 kW/2,8 KM"
            },
            {
                "name": "Szeroko\u015B\u0107 koszenia",
                "value": "46cm"
            },
            {
                "name": "Wysoko\u015B\u0107 koszenia",
                "value": "25-75cm"
            },
            {
                "name": "Pojemno\u015B\u0107 kosza na traw\u0119",
                "value": "55l"
            },
            {
                "name": "Ci\u0119\u017Car urz\u0105dzenia",
                "value": "26kg"
            },
            {
                "name": "Nap\u0119d k\xf3\u0142",
                "value": "1V (1 biegowy)"
            },
            {
                "name": "Urz\u0105dzenie (D\u0142./Szer./Wys.)",
                "value": "147cm x 50cm x 111cm"
            }
        ],
        "price": {
            "rental_price": "80z\u0142",
            "deposit": "250z\u0142"
        },
        "image": (0, $3aJhI.default).kosiarka3,
        "category": "Kosiarki i kosy"
    },
    {
        "id": 31,
        "name": "Laser krzy\u017Cowy PRO LK-180 G",
        "description": "Laser krzy\u017Cowy LK-180G generuje jedn\u0105 wi\u0105zk\u0119 pionow\u0105 oraz jedn\u0105 wi\u0105zk\u0119 poziom\u0105, obie o  zakresie pracy poszerzonym do 180\xb0. Zielone diody laserowe generuj\u0105 bardzo kontrastowe, dobrze widoczne linie, do 4 razy ja\u015Bniejsze ni\u017C w laserze czerwonym o tej samej mocy. Tryb pracy z detektorem wi\u0105zki laserowej, zwi\u0119kszaj\u0105cym zasi\u0119g lasera. Linie lasera przecinaj\u0105 si\u0119 pod k\u0105tem 90\xb0. Wyposa\u017Cony w magnetyczn\u0105 podstaw\u0119 z montowanym do \u015Bciany zaczepem oraz mosi\u0119\u017Cnymi gwintami 1/4\u201D\u201D i 5/8\u201D\u201D. \u0141atwy monta\u017C na statywie lub tyczce o gwintach 1/4\u201D\u201D lub 5/8\u201D\u201D. Specyfikacja techniczna:b \u0179r\xf3d\u0142o lasera:dioda p\xf3\u0142 przewodnikowa=515-520 nm Moc:<1mW ka\u017Cda wi\u0105zka, klasa II Dok\u0142adno\u015B\u0107:	+/-1mm/5m (+/-0,2mm/1m) Zakres samopoziomowania:	4o  +/- 1o Szeroko\u015B\u0107 linii	mniej ni\u017C 3,5mm/ 10m System samopoziomuj\u0105cy: wahad\u0142o magnetyczne Zakres roboczy do 15m w pomieszczeniu zale\u017Cnie od na\u015Bwietlenia oraz 40m przy u\u017Cyciu detektora Zasilanie:3xbateria alkaliczna AA Czas pracy ok. 4 godzin Wymiary: 90mmx70mmx90mm Waga(z bateriami) 400g K\u0105t linii poziomej/pionowej: 180o/180o Temperatura pracy: -5oC - 40oC Temperatura przechowywania: -20oC - 70oC Wyposa\u017Cenie: Laser krzy\u017Cowy LK-180G Uniwersalny uchwyt magnetyczny z ruchom\u0105 g\u0142owic\u0105 i gwintem 1/4",
        "technical_data": [
            {
                "name": "",
                "value": ""
            }
        ],
        "price": {
            "rental_price": "40z\u0142",
            "deposit": "200z\u0142"
        },
        "image": (0, $3aJhI.default).laserk,
        "category": "Elektronarz\u0119dzia"
    },
    {
        "id": 32,
        "name": "M\u0142otowiertarka akumulatorowa bezprzewodowa DHR241Z 18V 1.9J Makita",
        "description": "",
        "technical_data": [
            {
                "name": "Si\u0142a uderzeniowa",
                "value": "1.9J"
            },
            {
                "name": "\u015Arednica wiercenia w betonie",
                "value": "20mm"
            },
            {
                "name": "Funkcja przecinania",
                "value": "Tak"
            },
            {
                "name": "Napi\u0119cie",
                "value": "18V"
            },
            {
                "name": "\u015Arednica wiercenia w drewnie",
                "value": "26mm"
            },
            {
                "name": "\u015Arednica wiercenia w metalu",
                "value": "13mm"
            },
            {
                "name": "Czas \u0142adowania",
                "value": "90 minut"
            },
            {
                "name": "Typ uchwytu",
                "value": "SDS Plus"
            }
        ],
        "price": {
            "rental_price": "40z\u0142",
            "deposit": "150z\u0142"
        },
        "image": (0, $3aJhI.default).mlotowiertarka,
        "category": "Elektronarz\u0119dzia"
    },
    {
        "id": 33,
        "name": "Bezolejowy Kompresor FMXCMD156HE FATMAX",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "1100 W/1,5hk"
            },
            {
                "name": "Maks ci\u015Bnienie robocze",
                "value": "8 bar"
            },
            {
                "name": "Gwarantowany poziom mocy akustycznej",
                "value": "97dB"
            },
            {
                "name": "Pojemno\u015B\u0107 zbiornika",
                "value": "6l"
            },
            {
                "name": "Napi\u0119cie",
                "value": "230V"
            },
            {
                "name": "Wydajno\u015B\u0107",
                "value": "180 l/min"
            },
            {
                "name": "Wydajno\u015B\u0107 efektywna",
                "value": "130 l/min"
            }
        ],
        "price": {
            "rental_price": "80z\u0142",
            "deposit": "250z\u0142"
        },
        "image": (0, $3aJhI.default).kompresor,
        "category": "Narz\u0119dzia budowlane"
    },
    {
        "id": 34,
        "name": "DECA Spawarka transformatorowa PARVA 145E",
        "description": "",
        "technical_data": [
            {
                "name": "Zasilanie",
                "value": "230V"
            },
            {
                "name": "Bezpiecznik",
                "value": "16A"
            },
            {
                "name": "Moc silnika",
                "value": "2-4 kW"
            },
            {
                "name": "Napi\u0119cie obwodu otwartego",
                "value": "44-48 V"
            },
            {
                "name": "Zakres pr\u0105du sparowania",
                "value": "40-140A"
            },
            {
                "name": "\u015Arednica zalecanych elektrod",
                "value": "1,6 - 3,2mm"
            },
            {
                "name": "Rozmiar",
                "value": "380 x 210 x 280mm"
            },
            {
                "name": "Masa",
                "value": "14,5kg"
            }
        ],
        "price": {
            "rental_price": "80z\u0142",
            "deposit": "250z\u0142"
        },
        "image": (0, $3aJhI.default).spawarka,
        "category": "Narz\u0119dzia budowlane"
    },
    {
        "id": 35,
        "name": "RIWALL PRO DZIDA 1500 SZLIFIERKA \u017BYRAFA",
        "description": "",
        "technical_data": [
            {
                "name": "Moc silnika znamionowa",
                "value": "1500 W"
            },
            {
                "name": "Tarcze szlifierskie \xd8",
                "value": "225 mm"
            },
            {
                "name": "Pr\u0119dko\u015B\u0107 obr. tarczy szlifierskiej okr\u0105g\u0142ej",
                "value": "1000 \u2013 1850 /min"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 regulowana",
                "value": "110-180cm"
            },
            {
                "name": "Kr\xf3\u0107ce odci\u0105gowe: \xd8 ",
                "value": "wew. 45 / zew. 50 mm"
            },
            {
                "name": "Waga",
                "value": "4,5 kg"
            }
        ],
        "price": {
            "rental_price": "90z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).szlifierka2,
        "category": "Narz\u0119dzia budowlane"
    },
    {
        "id": 36,
        "name": "Makita DGA511Z Szlifierka K\u0105towa, 18 V, Czarny/Niebieski",
        "description": "",
        "technical_data": [
            {
                "name": "\u0179r\xf3d\u0142o",
                "value": "Zasilanie bateryjne"
            },
            {
                "name": "Napi\u0119cie",
                "value": "18w"
            },
            {
                "name": "Moc",
                "value": "50W"
            },
            {
                "name": "Maksymalna pr\u0119dko\u015B\u0107 obrotowa",
                "value": "8,5"
            },
            {
                "name": "Technologia wykrywania aktywnego sprz\u0119\u017Cenia zwrotnego",
                "value": ""
            },
            {
                "name": "Technologia automatycznego nap\u0119du momentu obrotowego ADT",
                "value": ""
            }
        ],
        "price": {
            "rental_price": "60z\u0142",
            "deposit": "250z\u0142"
        },
        "image": (0, $3aJhI.default).szlifierka1,
        "category": "Elektronarz\u0119dzia"
    },
    {
        "id": 37,
        "name": "Odkurzacz przemys\u0142owy wodny",
        "description": "",
        "technical_data": [
            {
                "name": "Waga",
                "value": "6,5kg"
            },
            {
                "name": "Napi\u0119cie",
                "value": "230V"
            },
            {
                "name": "Zasi\u0119g",
                "value": "6,8m"
            },
            {
                "name": "Pojemno\u015B\u0107",
                "value": "25l"
            },
            {
                "name": "Przep\u0142yw powietrza",
                "value": "2m3/min"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 w\u0119\u017Ca",
                "value": "1,8m"
            },
            {
                "name": "Poziom ha\u0142asu",
                "value": "78dB"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 kabla",
                "value": "5m"
            },
            {
                "name": "Moc",
                "value": "1200 W"
            }
        ],
        "price": {
            "rental_price": "30z\u0142",
            "deposit": "100z\u0142"
        },
        "image": (0, $3aJhI.default).odkurzacz,
        "category": "Elektronarz\u0119dzia"
    },
    {
        "id": 38,
        "name": "No\u017Cyce akumlatorowe Stihl HSA 56",
        "description": "",
        "technical_data": [
            {
                "name": "Waga",
                "value": "3,5kg"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 ci\u0119cia",
                "value": "45cm"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 ca\u0142kowita",
                "value": "94cm"
            },
            {
                "name": "Orientacyjny czas pracy z akumlatorem AK 10",
                "value": "do 40min"
            },
            {
                "name": "Orientacyjny czas pracy z akumlatorem AK 20",
                "value": "do 80min"
            }
        ],
        "price": {
            "rental_price": "150z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).nozyce3,
        "category": "No\u017Cyce do \u017Cywop\u0142otu i sekatory"
    },
    {
        "id": 39,
        "name": "No\u017Cyce na wysi\u0119gniku kombi system",
        "description": "",
        "technical_data": [
            {
                "name": "Moc",
                "value": "0,9 kW / 1,2KM"
            },
            {
                "name": "Pojemno\u015B\u0107",
                "value": "24,1 cm3"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 listwy tn\u0105cej",
                "value": "60cm"
            },
            {
                "name": "D\u0142ugo\u015B\u0107 ca\u0142kowita",
                "value": "242cm"
            },
            {
                "name": "Ilo\u015B\u0107 skok\xf3w",
                "value": "3.615/ min"
            }
        ],
        "price": {
            "rental_price": "120z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).kombii,
        "category": "No\u017Cyce do \u017Cywop\u0142otu i sekatory"
    },
    {
        "id": 40,
        "name": "Wertykulator Weibang WB384RB",
        "description": "",
        "technical_data": [
            {
                "name": "Silnik",
                "value": "Briggs & Stratton XR750"
            },
            {
                "name": "Pojemno\u015B\u0107 silnika",
                "value": "163 cm\xb3"
            },
            {
                "name": "Moc",
                "value": "3,7 kW"
            },
            {
                "name": "Szeroko\u015B\u0107 robocza",
                "value": "38 cm"
            },
            {
                "name": "Maks. g\u0142\u0119boko\u015B\u0107 pracy",
                "value": "16 mm"
            },
            {
                "name": "Ilo\u015B\u0107 no\u017Cy",
                "value": "22"
            },
            {
                "name": "Pojemno\u015B\u0107 kosza",
                "value": "40 l"
            },
            {
                "name": "Waga",
                "value": "46 kg"
            },
            {
                "name": "Zalecana powierzchnia",
                "value": "do 2000 m\xb2"
            }
        ],
        "price": {
            "rental_price": "120z\u0142",
            "deposit": "300z\u0142"
        },
        "image": (0, $3aJhI.default).weibangWertykulator,
        "category": "Wertykulatory i Aeratory"
    },
    {
        "id": 41,
        "name": "Glebogryzarka spalinowa Stihl MH 685",
        "description": "",
        "technical_data": [
            {
                "name": "Typ silnika",
                "value": "EVC 200.3 C"
            },
            {
                "name": "Pojemno\u015B\u0107 skokowa",
                "value": "139 cm\xb3"
            },
            {
                "name": "Moc",
                "value": "2,3 kW / 3,1 KM"
            },
            {
                "name": "Szeroko\u015B\u0107 robocza",
                "value": "45 cm"
            },
            {
                "name": "Maks. szeroko\u015B\u0107 robocza",
                "value": "60 cm"
            },
            {
                "name": "Pojemno\u015B\u0107 zbiornika paliwa",
                "value": "0,9 l"
            },
            {
                "name": "Ci\u0119\u017Car",
                "value": "36 kg"
            }
        ],
        "price": {
            "rental_price": "270z\u0142",
            "deposit": "500z\u0142"
        },
        "image": (0, $3aJhI.default).stihlMh685,
        "category": "Glebogryzarki"
    }
];
var $6c890dfcfb08bdd7$export$2e2bcd8739ae039 = $6c890dfcfb08bdd7$var$data;

});
parcelRegister("3aJhI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24f56ee4beef497a$export$2e2bcd8739ae039; });












































const $24f56ee4beef497a$var$imgs = {
    gardener: new URL((parcelRequire("jmjBJ"))),
    agregator: new URL((parcelRequire("g72Rz"))),
    zageszczarka1: new URL((parcelRequire("hGrGX"))),
    kompresor: new URL((parcelRequire("lKI9W"))),
    dakr1: new URL((parcelRequire("9G1Zw"))),
    spawarka: new URL((parcelRequire("ecIks"))),
    dmuchawa1: new URL((parcelRequire("9aaBW"))),
    dmuchawa2: new URL((parcelRequire("4jvBp"))),
    drabina: new URL((parcelRequire("h3T3R"))),
    nozyce1: new URL((parcelRequire("lOIuw"))),
    glebogryzarka: new URL((parcelRequire("fLmkU"))),
    kosa: new URL((parcelRequire("3sRDw"))),
    fs87: new URL((parcelRequire("4uc5R"))),
    kosiarka1: new URL((parcelRequire("1ATwA"))),
    kosiarka2: new URL((parcelRequire("8sdJ9"))),
    kosiarka3: new URL((parcelRequire("g3Tq9"))),
    minikoparka: new URL((parcelRequire("8lbUL"))),
    mlotowiertarka: new URL((parcelRequire("b9AmT"))),
    ms193: new URL((parcelRequire("9JUfe"))),
    ms200: new URL((parcelRequire("g6mHo"))),
    ms391: new URL((parcelRequire("hP4P5"))),
    nozyce2: new URL((parcelRequire("4rLj0"))),
    odkurzacz: new URL((parcelRequire("1QhdY"))),
    opryskiwacz: new URL((parcelRequire("1VTMH"))),
    przeczepka: new URL((parcelRequire("jv1cn"))),
    rebak: new URL((parcelRequire("bCcOG"))),
    siewnik: new URL((parcelRequire("awfOb"))),
    szlifierka1: new URL((parcelRequire("ibO53"))),
    szlifierka2: new URL((parcelRequire("1jrq4"))),
    taczki: new URL((parcelRequire("kHKo3"))),
    ts420: new URL((parcelRequire("hPmgz"))),
    walec: new URL((parcelRequire("lkrC4"))),
    wertykulator: new URL((parcelRequire("iip8L"))),
    zageszczarka2: new URL((parcelRequire("dpRp9"))),
    zageszczarka3: new URL((parcelRequire("iLIKV"))),
    zywoplotnica2: new URL((parcelRequire("hQjvh"))),
    fs55: new URL((parcelRequire("byb4S"))),
    laserk: new URL((parcelRequire("5UOP9"))),
    nozyce3: new URL((parcelRequire("jyetd"))),
    kombii: new URL((parcelRequire("3juCO"))),
    stihlMh685: new URL((parcelRequire("it7sx"))),
    weibangWertykulator: new URL((parcelRequire("h4Myn"))),
    crawler: new URL((parcelRequire("5yOXe"))),
    avant630: new URL((parcelRequire("8jGXa")))
};
var $24f56ee4beef497a$export$2e2bcd8739ae039 = $24f56ee4beef497a$var$imgs;

});
parcelRegister("jmjBJ", function(module, exports) {
module.exports = $parcel$resolve("eWscZ");

});

parcelRegister("g72Rz", function(module, exports) {
module.exports = $parcel$resolve("iUGfT");

});

parcelRegister("hGrGX", function(module, exports) {
module.exports = $parcel$resolve("hO8u8");

});

parcelRegister("lKI9W", function(module, exports) {
module.exports = $parcel$resolve("1sSrH");

});

parcelRegister("9G1Zw", function(module, exports) {
module.exports = $parcel$resolve("6pXLA");

});

parcelRegister("ecIks", function(module, exports) {
module.exports = $parcel$resolve("iHPBe");

});

parcelRegister("9aaBW", function(module, exports) {
module.exports = $parcel$resolve("l7EG6");

});

parcelRegister("4jvBp", function(module, exports) {
module.exports = $parcel$resolve("j5mtg");

});

parcelRegister("h3T3R", function(module, exports) {
module.exports = $parcel$resolve("f92cN");

});

parcelRegister("lOIuw", function(module, exports) {
module.exports = $parcel$resolve("hkyUe");

});

parcelRegister("fLmkU", function(module, exports) {
module.exports = $parcel$resolve("9naqD");

});

parcelRegister("3sRDw", function(module, exports) {
module.exports = $parcel$resolve("fEatZ");

});

parcelRegister("4uc5R", function(module, exports) {
module.exports = $parcel$resolve("k3wwW");

});

parcelRegister("1ATwA", function(module, exports) {
module.exports = $parcel$resolve("dg47w");

});

parcelRegister("8sdJ9", function(module, exports) {
module.exports = $parcel$resolve("9t1my");

});

parcelRegister("g3Tq9", function(module, exports) {
module.exports = $parcel$resolve("jdlGq");

});

parcelRegister("8lbUL", function(module, exports) {
module.exports = $parcel$resolve("gFVD0");

});

parcelRegister("b9AmT", function(module, exports) {
module.exports = $parcel$resolve("1Br58");

});

parcelRegister("9JUfe", function(module, exports) {
module.exports = $parcel$resolve("4xdpU");

});

parcelRegister("g6mHo", function(module, exports) {
module.exports = $parcel$resolve("3heQR");

});

parcelRegister("hP4P5", function(module, exports) {
module.exports = $parcel$resolve("2M0Ba");

});

parcelRegister("4rLj0", function(module, exports) {
module.exports = $parcel$resolve("2hggz");

});

parcelRegister("1QhdY", function(module, exports) {
module.exports = $parcel$resolve("7Rrn3");

});

parcelRegister("1VTMH", function(module, exports) {
module.exports = $parcel$resolve("gvhv4");

});

parcelRegister("jv1cn", function(module, exports) {
module.exports = $parcel$resolve("lL0gy");

});

parcelRegister("bCcOG", function(module, exports) {
module.exports = $parcel$resolve("2EBOS");

});

parcelRegister("awfOb", function(module, exports) {
module.exports = $parcel$resolve("2RXcA");

});

parcelRegister("ibO53", function(module, exports) {
module.exports = $parcel$resolve("6qZWd");

});

parcelRegister("1jrq4", function(module, exports) {
module.exports = $parcel$resolve("bc1fH");

});

parcelRegister("kHKo3", function(module, exports) {
module.exports = $parcel$resolve("dXLwo");

});

parcelRegister("hPmgz", function(module, exports) {
module.exports = $parcel$resolve("czpID");

});

parcelRegister("lkrC4", function(module, exports) {
module.exports = $parcel$resolve("30Bx9");

});

parcelRegister("iip8L", function(module, exports) {
module.exports = $parcel$resolve("bSrJj");

});

parcelRegister("dpRp9", function(module, exports) {
module.exports = $parcel$resolve("5751X");

});

parcelRegister("iLIKV", function(module, exports) {
module.exports = $parcel$resolve("kKXvv");

});

parcelRegister("hQjvh", function(module, exports) {
module.exports = $parcel$resolve("9jxp3");

});

parcelRegister("byb4S", function(module, exports) {
module.exports = $parcel$resolve("9Bypj");

});

parcelRegister("5UOP9", function(module, exports) {
module.exports = $parcel$resolve("d3r68");

});

parcelRegister("jyetd", function(module, exports) {
module.exports = $parcel$resolve("hwWhd");

});

parcelRegister("3juCO", function(module, exports) {
module.exports = $parcel$resolve("bgVYS");

});

parcelRegister("it7sx", function(module, exports) {
module.exports = $parcel$resolve("emm4a");

});

parcelRegister("h4Myn", function(module, exports) {
module.exports = $parcel$resolve("8pn3J");

});

parcelRegister("5yOXe", function(module, exports) {
module.exports = $parcel$resolve("fgDUY");

});

parcelRegister("8jGXa", function(module, exports) {
module.exports = $parcel$resolve("i9xat");

});



var $4ee90a5767898ff4$exports = {};
$parcel$extendImportMap({
    "eWscZ": "gardener.4b1a7083.webp",
    "iUGfT": "agregator rurkowy weibang.cbfa9782.webp",
    "hO8u8": "zageszczarka belle120.5b70f4bb.webp",
    "1sSrH": "bezolejowy kompresor.b8532fce.webp",
    "6pXLA": "dakr.70397e82.webp",
    "iHPBe": "deca spawarka.dbdd039b.webp",
    "l7EG6": "dmiuchawa bg86.0adf4937.webp",
    "j5mtg": "dmuchawa sh56.33797208.webp",
    "f92cN": "drabina.b885fb44.webp",
    "hkyUe": "elektryczne nozyce do zywoplotu.bdaa5399.webp",
    "9naqD": "glebogryzarka viking hb 560.89eaf3fc.webp",
    "fEatZ": "kosa spalinowa shihl fs 240.17df728f.webp",
    "k3wwW": "fs87.b0ba0255.webp",
    "dg47w": "kosiarka briggs.92ae25f9.webp",
    "9t1my": "kosiarka spalinowa castel.66e5152a.webp",
    "jdlGq": "kosiarka spalinowa z napedem viking.7adbbd00.webp",
    "gFVD0": "minikoparka jbc 80818.2ff5c860.webp",
    "1Br58": "mlotowiertarka.f9a2f183.webp",
    "4xdpU": "ms193.27eb394a.webp",
    "3heQR": "ms200.cd173451.webp",
    "2M0Ba": "ms391.24d2f6e3.webp",
    "2hggz": "nozyce spalinowe.61540973.webp",
    "7Rrn3": "odkurzacz przemys\u0142owy.f13a3aa2.webp",
    "gvhv4": "opryskiwacz spalinowy stihl.ed839f7e.webp",
    "lL0gy": "przeczepka.499cd4ab.webp",
    "2EBOS": "rebak timberwolf.16bf388b.webp",
    "2RXcA": "siewnik wolf garten.f940939d.webp",
    "6qZWd": "szlifierka katowa.d21ada9f.webp",
    "bc1fH": "szlifierka zyrafa.dd954dd4.webp",
    "dXLwo": "taczki cedrus.99183d70.webp",
    "czpID": "ts420.dcc00e13.webp",
    "30Bx9": "walec napowieczacz.3742b9a7.webp",
    "bSrJj": "wertykulator world.4800aba8.webp",
    "5751X": "zageszczarka 196cc.a16a0a19.webp",
    "kKXvv": "zageszczarka belle.ba7744bc.webp",
    "9jxp3": "zywoplotnica.71576d55.webp",
    "9Bypj": "fs55.26d39063.webp",
    "d3r68": "laserk.ae18c24b.webp",
    "hwWhd": "nozyce akumlatorowe.29ef778a.webp",
    "bgVYS": "kombii system.1a565982.webp",
    "emm4a": "stihl-mh-685.22f7192b.png",
    "8pn3J": "weibang-wertykulator.c0d1609c.jpg",
    "fgDUY": "crawler.8cf514c6.webp",
    "i9xat": "63000.7f4af748.webp"
});


parcelRequire("9jJkP");

//# sourceMappingURL=cennik-maszyn.41b0e07b.js.map
